// NUDE BUT DRESSED — after a successful add-to-cart, go to the cart page.
// Only loaded when cart_type == 'page' and we're not already on /cart.
// Rides the theme's own cart event so it stays in sync with the AJAX add.

import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  // The event carries a promise resolving to { cart, detail }.
  const promise = /** @type {any} */ (event).promise;
  if (!promise || typeof promise.then !== 'function') return;

  promise
    .then((/** @type {any} */ payload) => {
      const detail = payload && payload.detail;
      if (!detail) return;
      // Only redirect for adds coming from a product form, and only on success.
      if (detail.source !== 'product-form-component') return;
      if (detail.didError) return;

      const cartUrl =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
      window.location.assign(cartUrl);
    })
    .catch(() => {
      /* ignore aborted / rejected cart events */
    });
});
